import { getClasses } from '../../utils/styler';

const Button = ({ type, buttonWithIcon, buttonError, onClick, disabled, children, ...props }) => (
	<button className={getClasses({ ...props }, {
		'af-button': true,
		[`af-button--${type}`]: type,
		'af-button--error': buttonError,
		'af-button--icon': buttonWithIcon
	})} disabled={disabled} onClick={onClick}>
		{ children}
	</button>
);

export default Button;
